import cls from 'classnames';

import { ITooltipProps } from './types';
import useStyles from './styles';

export default function Tooltip({
  children,
  color = 'black',
  className,
  withArrow = true,
  arrowType = 'down',
  arrowClassName,
}: ITooltipProps) {
  const classes = useStyles();

  return (
    <div className={cls(classes.root, classes[color], className)}>
      <div>{children}</div>
      {withArrow && (
        <div className={cls(classes.arrowContainer, arrowType, arrowClassName)}>
          <div className={classes.arrow} />
        </div>
      )}
    </div>
  );
}
